import { type ReactElement } from 'react';
import type React from 'react';

import { useDragLayer } from 'react-dnd';

import { layerStyles } from './styles';
import { getItemStyles } from './utils';

interface CustomDragLayerProps {
  renderLayer: (dragItem) => ReactElement;
}

const CustomDragLayer: React.FC<React.PropsWithChildren<CustomDragLayerProps>> = ({ renderLayer }) => {
  const { isDragging, item, initialOffset, currentOffset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging) {
    return null;
  }
  return renderLayer ? (
    <div className={layerStyles().className}>
      <div style={getItemStyles(initialOffset, currentOffset)}>{renderLayer(item)}</div>
    </div>
  ) : null;
};

export default CustomDragLayer;
